import { connect } from 'react-redux';
import { TagWithIconComponent } from './tag-with-icon.component';

const mapStateToProps = ({ lang }) => ({
  lang: lang.TAGS,
});

export const TagWithIcon = connect(mapStateToProps)(TagWithIconComponent);
